export const CONST_STORAGE_PREFIX = 'CCDC_VER_1.0_'
export const CONST_SIGNATURE_WIDTH = 220
export const CONST_SIGNATURE_HEIGHT = 90

export const CONST_DEFAULT_LAT = 23.173214
export const CONST_DEFAULT_LNG = 113.43403
